import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';

export function* depthSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
) {
  const newValue: number = payload.value;
  if (cabinetOrigin.depth !== newValue || !payload.preview) {
    cabinetNext.depth = newValue;
    return {
      ignore: false,
      postSuccess: null,
    };
  } else return { ignore: true };
}

export function* widthSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
) {
  const newValue: number = payload.value;
  if (cabinetOrigin.width !== newValue || !payload.preview) {
    cabinetNext.width = newValue;
    return {
      ignore: false,
      postSuccess: null,
    };
  } else return { ignore: true };
}
